<div style="padding: 30px;">

    <!-- 說明區塊 -->
    <div class="card mb-4">
        <div class="card-header bg-danger text-white">
            <h5 class="mb-0">高風險流失價值用戶</h5>
        </div>
        <div class="card-body">
            <h6 class="font-weight-bold">資格條件</h6>
            <ol>
                <li>本身為儲值用戶</li>
                <li>30天內有上線</li>
                <li>註冊超過7天（確保用戶本身穩定使用系統）</li>
            </ol>
            <hr>
            <h6 class="font-weight-bold">分數計算（分數越高，流失風險越大）</h6>
            <table class="table table-sm table-bordered score-table">
                <thead class="thead-light">
                    <tr>
                        <th>項目</th>
                        <th>條件</th>
                        <th>得分</th>
                        <th>最高分</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td rowspan="3">沒登入</td>
                        <td>第一個門檻</td>
                        <td>10</td>
                        <td rowspan="3">40</td>
                    </tr>
                    <tr>
                        <td>第二個門檻</td>
                        <td>13</td>
                    </tr>
                    <tr>
                        <td>第三個門檻</td>
                        <td>17</td>
                    </tr>
                    <tr>
                        <td rowspan="3">沒消費</td>
                        <td>第一個門檻</td>
                        <td>8</td>
                        <td rowspan="3">30</td>
                    </tr>
                    <tr>
                        <td>第二個門檻</td>
                        <td>10</td>
                    </tr>
                    <tr>
                        <td>第三個門檻</td>
                        <td>12</td>
                    </tr>
                    <tr>
                        <td rowspan="3">超過10天沒儲值</td>
                        <td>11 ~ 15 天</td>
                        <td>+1 / 天</td>
                        <td rowspan="3">30</td>
                    </tr>
                    <tr>
                        <td>16 ~ 20 天</td>
                        <td>+2 / 天</td>
                    </tr>
                    <tr>
                        <td>21 天以上</td>
                        <td>+3 / 天</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- 搜尋列 -->
    <div class="mb-3 d-flex align-items-center">
        <input
            type="text"
            class="form-control"
            style="width: 220px; margin-right: 10px;"
            placeholder="搜尋用戶名稱 / 手機"
            [(ngModel)]="tool_obj.search_model"
            (keyup.enter)="init_list()"
        >
        <button class="btn btn-primary" (click)="init_list()">搜尋</button>
        <span class="ml-3 text-muted">共 {{pageobj.total_count}} 筆</span>
    </div>

    <!-- 資料表 -->
    <app-table-v2
        [type]="1"
        [data]="data"
        [tcontent]="tcontent"
        *ngIf="data.length > 0"
        (sortdata)="handlesortdata($event)"
    >
        <ng-template let-post #operation_dk>
            <div *ngIf="post.key == 'total_score'">
                <span
                    class="badge badge-pill"
                    [ngClass]="{
                        'badge-danger':  post.val.total_score >= 70,
                        'badge-warning': post.val.total_score >= 40 && post.val.total_score < 70,
                        'badge-info':    post.val.total_score < 40
                    }"
                    style="font-size: 14px;"
                >
                    {{ post.val.total_score }}
                </span>
            </div>
        </ng-template>
    </app-table-v2>

    <div *ngIf="data.length == 0 && !loading" class="text-muted mt-3">無資料</div>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>

</div>

<app-spinner [loading]="loading"></app-spinner>
